export { default } from './SearchSection';
export type {
	SearchSectionProps,
	SearchSectionSelectProps,
	SearchSectionInputProps,
	SearchOption,
	StrapiSearchOption
} from './types';
